module.exports = __webpack_public_path__ + "img/twitter-logo-full.04fd3b09.png";